import {
  GET_INFRASTRUCTURE_DETAILS,
  GET_TIME_SLOT,
  GET_WORKING_HOURS_SLOT,
} from "../../Utils/types";

const initialState = {
  getInfrastructureDetails: {},
  getTimeSlot: [],
  getWorkingHoursSlot: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INFRASTRUCTURE_DETAILS:
      return {
        ...state,
        getInfrastructureDetails: action.payload,
      };
    case GET_TIME_SLOT:
      return {
        ...state,
        getTimeSlot: action.payload,
      };
    case GET_WORKING_HOURS_SLOT:
      return {
        ...state,
        getWorkingHoursSlot: action.payload,
      };
    default:
      return state;
  }
};
